/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductRegisterReqVo } from './ProductRegisterReqVo';
import {
    ProductRegisterReqVoFromJSON,
    ProductRegisterReqVoFromJSONTyped,
    ProductRegisterReqVoToJSON,
    ProductRegisterReqVoToJSONTyped,
} from './ProductRegisterReqVo';

/**
 * 
 * @export
 * @interface ProductBatchRegisterReqVo
 */
export interface ProductBatchRegisterReqVo {
    /**
     * 待注册的 SPU 列表，结构同 ProductRegisterReqVO
     * @type {Array<ProductRegisterReqVo>}
     * @memberof ProductBatchRegisterReqVo
     */
    products: Array<ProductRegisterReqVo>;
}

/**
 * Check if a given object implements the ProductBatchRegisterReqVo interface.
 */
export function instanceOfProductBatchRegisterReqVo(value: object): value is ProductBatchRegisterReqVo {
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function ProductBatchRegisterReqVoFromJSON(json: any): ProductBatchRegisterReqVo {
    return ProductBatchRegisterReqVoFromJSONTyped(json, false);
}

export function ProductBatchRegisterReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductBatchRegisterReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'products': ((json['products'] as Array<any>).map(ProductRegisterReqVoFromJSON)),
    };
}

export function ProductBatchRegisterReqVoToJSON(json: any): ProductBatchRegisterReqVo {
    return ProductBatchRegisterReqVoToJSONTyped(json, false);
}

export function ProductBatchRegisterReqVoToJSONTyped(value?: ProductBatchRegisterReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': ((value['products'] as Array<any>).map(ProductRegisterReqVoToJSON)),
    };
}

